var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyPolicyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m351 8.787v91.213h91.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.875 192h-61.75c-11.688 20.403-31.424 34.318-54.125 38.603v71.995c0 54.256 33.971 101.385 85 118.66 51.029-17.275 85-64.404 85-118.66v-71.995c-22.701-4.285-42.437-18.201-54.125-38.603zm22.158 97.322-56.568 56.568c-2.929 2.929-6.768 4.394-10.606 4.394s-7.678-1.464-10.606-4.394l-28.284-28.284c-5.858-5.858-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0l17.678 17.677 45.962-45.961c5.857-5.858 15.355-5.858 21.213 0 5.856 5.858 5.856 15.355-.002 21.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336 130c-8.284 0-15-6.716-15-15v-115h-205c-30.327 0-55 24.673-55 55v402c0 30.327 24.673 55 55 55h280c30.327 0 55-24.673 55-55v-327zm35 172.597c0 33.654-10.619 65.715-30.708 92.716-20.089 27-47.747 46.384-79.982 56.054-1.406.422-2.858.633-4.31.633s-2.904-.211-4.31-.633c-32.235-9.67-59.893-29.054-79.982-56.054-20.089-27.001-30.708-59.062-30.708-92.716v-85.597c0-8.284 6.716-15 15-15 18.955 0 35.996-10.532 44.472-27.485l2.111-4.222c2.541-5.083 7.735-8.293 13.417-8.293h80c5.682 0 10.876 3.21 13.417 8.292l2.111 4.223c8.476 16.953 25.517 27.485 44.472 27.485 8.284 0 15 6.716 15 15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicyIcon);
export default __webpack_public_path__ + "static/media/privacy-policy-icon.f580a24f768368cf76597a64edf1ce8a.svg";
export { ForwardRef as ReactComponent };